import React from 'react';

// Defence panel (prototype left column). Controls grouped by category as left-cyan
// rows. Relationship states: selected row glows cyan; when a technique is selected,
// the controls that mitigate it are `linked` (coral, "mitigates") and the rest dim.
const ControlList = ({
  controls,
  selectedControl,
  onControlSelect,
  renderText,
  controlName,
  hint,
  highlightIds = null,
}) => {
  const categories = Object.entries(controls);
  const hasControls = categories.some(([, c]) => (c?.controls || []).length > 0);

  const rowClass = (id) => {
    const related = highlightIds && highlightIds.has(id);
    const dimmed = highlightIds && !related && selectedControl !== id;
    return [
      'tv-row def',
      selectedControl === id ? 'sel' : '',
      related ? 'linked' : '',
      dimmed ? 'dim' : '',
    ].join(' ');
  };

  return (
    <div className="tv-panel">
      <h2>
        <span className="tv-ph-dot" style={{ background: 'var(--tv-defence)' }} />
        Controls — Defence
      </h2>
      <p className="tv-hint">{hint}</p>

      {hasControls ? (
        categories.map(([category, list]) => {
          const ids = list?.controls || [];
          if (ids.length === 0) return null;
          return (
            <div className="tv-grp" key={category}>
              <div className="tv-gl">{renderText ? renderText(category) : category}</div>
              {ids.map((id) => {
                const name = controlName ? controlName(id) : '';
                const linked = highlightIds && highlightIds.has(id);
                return (
                  <button key={id} className={rowClass(id)} onClick={() => onControlSelect(id)}>
                    <span className="tv-rid">{renderText ? renderText(id) : id}</span>
                    <span style={{ flex: 1 }}>
                      <span className="tv-rn">{renderText && name ? renderText(name) : name}</span>
                    </span>
                    {linked && <span className="tv-link-tag">mitigates</span>}
                  </button>
                );
              })}
            </div>
          );
        })
      ) : (
        <p className="tv-empty">No controls match the current filter.</p>
      )}
    </div>
  );
};

export default ControlList;
